import { HorizontalBar , mixins } from 'vue-chartjs';

const { reactiveProp } = mixins

export default {
  extends: HorizontalBar ,   
  mixins: [reactiveProp],
  props: ['chartData', 'options'],  
  mounted () {
     this.$data._plugins.push({
       afterDraw: function (chart) {
         const chartInstance = chart;
         const ctx = chartInstance.ctx;
         ctx.textAlign = 'left';

         ctx.fillStyle = "rgba(0, 0, 0, 1)";
         ctx.textBaseline = 'bottom';
         var fontSize = 12;
         var fontStyle = 'bold';
         var fontFamily = 'Helvetica Neue';
         ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
        
         chart.chart.chart.data.datasets.forEach(function (dataset, i) {
             var meta = chartInstance.controller.getDatasetMeta(i);
             Chart.helpers.each(meta.data.forEach(function(bar, index) {
              var data = dataset.data[index];
              var barWidth = bar._model.x - bar._model.base;
              var centerX = bar._model.base + barWidth / 2;
              if (i == 0) {
                 ctx.fillText(data, centerX, bar._model.y + 4);
              } else {
                 ctx.fillText(data, centerX, bar._model.y + 4);
              }
           }), this);
            //  meta.data.forEach(function (bar, index) {
            //    var data = dataset.data[index];             

            //    if (data != 0){
            //     ctx.fillText(data, bar._model.x, bar._model.y + 4);                
            //     //ctx.fillText('(100%)', bar._model.x, bar._model.y - 5);
            //    }               
            //  });
         });
       }
     });

    this.renderChart(this.chartData, this.options);
  }
}